export default {"src":"/_next/static/media/img-fieldwork-in-progress.8b4be845.svg","height":170,"width":176,"blurWidth":0,"blurHeight":0};